import { Grid, Switch, Typography, useTheme } from '../../../../../../base-components';
import { useFormContext } from 'react-hook-form';
import { ITableForm, TableFormValues } from '../../../../../../../common';
import { useAppDispatch } from '../../../../../../base-redux';
import { tablesActions } from '../../../../../../../actions';
import { getBasicColorsObject } from '../../../../../../../common';
import { ITableToggle } from '../../../../../table.interfaces';

interface ITableToggleProps {
    toggle: ITableToggle;
}

const TableToggle = ({ toggle }: ITableToggleProps) => {
    const { key, label } = toggle;
    const { getValues, setValue } = useFormContext<ITableForm>();
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const baseColors = getBasicColorsObject(theme.palette);

    const currentToggles = getValues(TableFormValues.toggles) || {};
    const isChecked = currentToggles[key] ?? toggle.defaultValue;

    const handleChange = () => {
        const newValue = !isChecked;
        const updatedToggles = { ...currentToggles, [key]: newValue };
        setValue(TableFormValues.toggles, updatedToggles);

        const formData = getValues();
        dispatch(
            tablesActions.fetchTableDataById({
                tableId: formData.tableId,
                formData: { ...formData, toggles: updatedToggles },
                page: 1,
                baseColors,
            })
        );
    };

    return (
        <Grid display="flex" alignItems="center" gap={0.5}>
            <Switch
                checked={isChecked}
                onChange={handleChange}
                size="small"
                color="secondary"
            />
            <Typography
                variant="body2"
                color={theme.palette.grey[600]}
                sx={{ userSelect: 'none', cursor: 'pointer' }}
                onClick={handleChange}
            >
                {label}
            </Typography>
        </Grid>
    );
};

export default TableToggle;
